import React from 'react';
import WeeklySales from './WeeklySales';
import { Row, Col } from 'react-bootstrap';
import WelcomeMessage from 'components/common/WelcomeMessage';
import { useDashboard } from 'providers/DashboardProvider';
import {
  weather,
  products,
  storageStatus,
  files,
  users,
  topProducts
} from 'data/dashboard/default';

import TotalOrder from './TotalOrder';
import MarketShare from './MarketShare';
import TotalSales from './TotalSales';
import StorageStatus from './StorageStatus';
import SpaceWarning from './SpaceWarning';
import BestSellingProducts from './BestSellingProducts';
import SharedFiles from './SharedFiles';
import ActiveUsers from './ActiveUsers';
import BandwidthSaved from './BandwidthSaved';
import TopProducts from './TopProducts';
import Weather from './Weather';

const Dashboard = () => {
  const {
    weeklySalesData,
    weeklySalesTotalLabel,
    weeklySalesTrendLabel,
    weeklySalesTrendUp,
    totalOrderData,
    totalOrderTotalLabel,
    totalOrderTrendLabel,
    totalOrderTrendUp,
    marketShareData,
    totalSalesByYear,
    submittedYears,
    syncing
  } = useDashboard();

  return (
    <>
      <WelcomeMessage />
      {syncing && (
        <div className="d-flex justify-content-end align-items-center text-muted mb-2" style={{ fontSize: 12 }}>
          Syncing latest data…
        </div>
      )}
      <div style={{ opacity: syncing ? 0.55 : 1, transition: "opacity 150ms ease" }}>
      <Row className="g-3 mb-3">
        <Col md={6} xxl={3}>
          <WeeklySales
            data={weeklySalesData}
            totalLabel={weeklySalesTotalLabel}
            trendLabel={weeklySalesTrendLabel}
            trendUp={weeklySalesTrendUp}
          />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder
            data={totalOrderData}
            totalLabel={totalOrderTotalLabel}
            trendLabel={totalOrderTrendLabel}
            trendUp={totalOrderTrendUp}
          />
        </Col>
        <Col md={6} xxl={3}>
          <MarketShare data={marketShareData} radius={['100%', '87%']} />
        </Col>
        <Col md={6} xxl={3}>
          <Weather data={weather} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6}>
          <TotalSales
            dataByYear={totalSalesByYear}
            years={submittedYears}
          />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6} xl={7} xxl={8}>
          <StorageStatus className="h-lg-100" data={storageStatus} />
        </Col>
        <Col lg={6} xl={5} xxl={4}>
          <SpaceWarning />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={7} xl={8}>
          <BestSellingProducts products={products} />
        </Col>
        <Col lg={5} xl={4}>
          <SharedFiles files={files} className="h-lg-100" />
        </Col>
      </Row>

      <Row className="g-3">
        <Col sm={6} xxl={3}>
          <ActiveUsers className="h-100" users={users} />
        </Col>
        <Col sm={6} xxl={3} className="order-xxl-1">
          <BandwidthSaved />
        </Col>
        <Col xxl={6}>
          <TopProducts data={topProducts} className="h-100" />
        </Col>
      </Row>
      </div>
    </>
  );
};

export default Dashboard;
